import { render, staticRenderFns } from "./providerCard.vue?vue&type=template&id=7523bb70&scoped=true&"
import script from "./providerCard.vue?vue&type=script&lang=js&"
export * from "./providerCard.vue?vue&type=script&lang=js&"
import style0 from "./providerCard.vue?vue&type=style&index=0&id=7523bb70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7523bb70",
  null
  
)

export default component.exports